(() => {
  'use strict';
  const shop = document.getElementById('explore');
  if (!shop?.classList.contains('home-shop')) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(pointer: fine)');
  const fallback = shop.querySelector('.home-shop-fallback');
  const sticky = document.querySelector('.sticky-cta');
  const primaryActions = [...document.querySelectorAll('.hero-cta,.os-cta,#home-close .home-action')];
  function arrowIcon(external = false) {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('class', 'home-icon');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    const path = document.createElementNS(svg.namespaceURI, 'path');
    path.setAttribute('d', external ? 'M6 18 18 6M6 6h12v12' : 'M4 12h16m-6-6 6 6-6 6');
    svg.append(path);
    return svg;
  }
  document.querySelectorAll('.home-lower-link>span,.home-action>span,.home-work-destination>span,.os-cta>span,.os-next>span').forEach(span => {
    const link = span.closest('a');
    span.replaceChildren(arrowIcon(!!link && new URL(link.href).origin !== new URL(document.baseURI).origin));
    span.setAttribute('aria-hidden', 'true');
  });
  const products = {
    'custom-stickers': {image:(window.VP_CDN+"vp-stickers__card-pile.webp?v=02dec90fa2"), alt:'Die-cut stickers and a labeled jar: a pear, a mushroom, a rainbow star, a dog and a flower', width:1600, height:1310, name:'Custom Stickers', description:'Die cut, kiss cut and sheets. Your choice of material and finish.'},
    labels: {image:(window.VP_CDN+"builder-renders__roll-labels-vp-holo.webp?v=eebea4bbe5"), alt:'Roll of holographic VINYLPAC labels', width:1632, height:1032, name:'Labels', description:'Custom product labels, on sheets or rolls.'},
    packaging: {image:(window.VP_CDN+"builder-renders__jar-lineup-emboss.webp?v=7cd9fc1823"), alt:'Embossed VINYLPAC labels on 4 oz, 150 ml and 5 ml glass jars', width:1421, height:990, name:'Custom Packaging', description:'Jar-label sets and glass jars.'},
    jars: {image:(window.VP_CDN+"home-refresh__jars.webp?v=ecacc8f20e"), alt:'Empty black glass jars', width:360, height:360, name:'Glass Jars', description:'Miron violet and black glass, by the pack or case.'},
    posters: {image:(window.VP_CDN+"home-refresh__posters.webp?v=41d45b7ce7"), alt:'VINYLPAC custom poster example', width:749, height:909, name:'Posters & More', description:'Posters, banners and yard signs.'}
  };

  if (shop.querySelector('#cards-placeholder')) {
  VP.inject('cards-placeholder', 'accordion.html').then(() => {
    const cards = shop.querySelectorAll('.xpl-card');
    if (cards.length !== Object.keys(products).length) throw new Error('Product categories unavailable');
    cards.forEach((card, index) => {
      const product = products[card.dataset.family];
      const image = card.querySelector('.xpl-thumb');
      if (image && product) {
        image.src = product.image;
        image.alt = product.alt;
        image.width = product.width;
        image.height = product.height;
        image.loading = 'lazy';
        image.decoding = 'async';
        card.querySelector('.xpl-name').textContent = product.name;
        card.querySelector('.xpl-desc').textContent = product.description;
      }
      const number = document.createElement('span');
      number.className = 'home-shop-number';
      number.textContent = String(index + 1).padStart(2, '0');
      number.setAttribute('aria-hidden', 'true');
      card.append(number);
      const fold = document.createElement('span');
      fold.className = 'home-shop-fold';
      fold.setAttribute('aria-hidden', 'true');
      card.append(fold);
      const arrow = card.querySelector('.xpl-arrow');
      if (arrow) { arrow.replaceChildren(arrowIcon()); arrow.setAttribute('aria-hidden', 'true'); }
      card.addEventListener('pointermove', event => {
        if (reduced.matches || !finePointer.matches || event.pointerType === 'touch') return;
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--tile-x', ((event.clientX - rect.left) / rect.width * 10 - 5).toFixed(2) + 'deg');
        card.style.setProperty('--tile-y', (5 - (event.clientY - rect.top) / rect.height * 10).toFixed(2) + 'deg');
        card.style.setProperty('--tile-lift', '-4px');
      }, {passive:true});
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--tile-x', '0deg');
        card.style.setProperty('--tile-y', '0deg');
        card.style.setProperty('--tile-lift', '0px');
      });
    });
    shop.dataset.ready = 'true';
  }).catch(() => {
    if (fallback) shop.querySelector('.home-cards-host').replaceChildren(fallback);
    shop.dataset.ready = 'failed';
  });
  } else {
    shop.dataset.ready = 'true';
  }

  let queued = false;
  function updateScroll() {
    queued = false;
    if (document.hidden) return;
    const rect = shop.getBoundingClientRect();
    if (sticky) {
      const hero = primaryActions[0]?.getBoundingClientRect();
      const primaryVisible = primaryActions.some(action => {
        const bounds = action.getBoundingClientRect();
        return bounds.width > 0 && bounds.top < innerHeight && bounds.bottom > 58;
      });
      const shopVisible = rect.top < innerHeight && rect.bottom > 58;
      const visible = !!hero && hero.bottom <= 58 && !primaryVisible && !shopVisible;
      sticky.dataset.visible = String(visible);
      sticky.setAttribute('aria-hidden', String(!visible));
      sticky.tabIndex = visible ? 0 : -1;
    }
    const offset = (innerHeight / 2 - rect.top - rect.height / 2) / innerHeight;
    shop.style.setProperty('--shop-scroll', reduced.matches ? 0 : Math.max(-1, Math.min(1, offset)));
  }
  function requestUpdate() {
    if (!queued) { queued = true; requestAnimationFrame(updateScroll); }
  }
  addEventListener('scroll', requestUpdate, {passive:true});
  addEventListener('resize', requestUpdate, {passive:true});
  addEventListener('load', requestUpdate);
  addEventListener('pageshow', requestUpdate);
  document.addEventListener('visibilitychange', requestUpdate);
  document.fonts?.ready?.then(requestUpdate);
  reduced.addEventListener('change', requestUpdate);
  updateScroll();

  // The phone menu (open, close, Escape, taps outside) is nav.html's alone, on every page.
})();
